import SftpDatumItem from "../Domain/SftpDatumItem.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from '../Elements/SearchParams';
import SftpAdminSearchParams from '../Contents/RoverImport/Sftp/SftpAdminSearchParams';

class SftpDatumService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, SftpAdminSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/SftpDatum/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new SftpDatumItem(item));
    }

    return [];
  }

  static EditSftpDatum(sftpDatum) {
    sftpDatum = serviceHelper.ConvertAllPropertyToString(sftpDatum);
    const sftpDatumJSON = JSON.stringify(sftpDatum);

    return AuthService.getInstance().CallBackendFunctionPut('/api/SftpDatum/EditSftpDatum', sftpDatumJSON);
  }
}

export default SftpDatumService;
